export default __webpack_public_path__ + "static/media/intellectual.7effa5b8.svg";